import React from 'react';

interface ColorManagerProps {
  detectedColors: {originalRgb: string, currentHex: string, count: number}[];
  updateColor: (originalRgb: string, newHex: string) => void;
}

export const ColorManager: React.FC<ColorManagerProps> = ({ detectedColors, updateColor }) => {
  return (
    <div className="space-y-4 p-6">
      <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-widest">Cores do Site</h3>
      {detectedColors.map((color, idx) => (
        <div key={idx} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
          <div className="flex items-center gap-3">
             <div className="w-8 h-8 rounded-md shadow-inner border border-gray-200" style={{ backgroundColor: color.currentHex }}></div>
             <span className="text-xs font-mono font-medium text-gray-700">{color.currentHex.toUpperCase()}</span>
          </div>
          <input 
            type="color" 
            value={color.currentHex} 
            onChange={e => updateColor(color.originalRgb, e.target.value)} 
            className="w-8 h-8 cursor-pointer border-0 p-0 rounded-lg bg-transparent" 
          />
        </div>
      ))}
    </div>
  );
};
